const validator = {
  reg: {
    phone: /^1[3|4|5|6|7|8|9]\d{9}$/,
    telephone: /^0\d{2,3}-\d{7,8}$/,
    positiveInteger: /^[0-9]{1,9}$/,
    validateNumber: /^[0-9]*$/,
  },
}
export default validator
